import { Context } from '@/context/appContext';
import { AppStateActions } from '@/reducers/appReducer';
import { AppBar, Dialog, IconButton, Toolbar } from '@mui/material';
import { CloseIcon } from '@/icons';
import { useContext } from 'react';
import { AuthView } from './AuthView';
import { RestoreView } from './RestoreView';
import { useIsMobile } from '@/hooks/useIsMobile';

function AuthModal() {
  const {
    state: { authState },
    dispatch,
  } = useContext(Context);
  const isMobile = useIsMobile();

  const handleClose = () => dispatch({ type: AppStateActions.SET_AUTH_STATE, payload: {} });

  return (
    <Dialog onClose={handleClose} open={!!authState.state} fullScreen={isMobile}>
      {isMobile && (
        <AppBar position="static" color="transparent" elevation={0}>
          <Toolbar sx={{ justifyContent: 'flex-end' }}>
            <IconButton onClick={handleClose} edge="end" aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      )}
      {authState.state === 'RESTORE' ? <RestoreView /> : <AuthView />}
    </Dialog>
  );
}

export { AuthModal };
